import { processCheckout, verifyMsisdin } from "../../../service/api";
import Input from "../../form-controls/Input";
import PopUp from "../../ui/PopUp";
import PrimaryButton from "../../ui/PrimaryButton";
import VerificationBox from "./VerificationBox";
import verified from "../../../assets/images/verified.svg";
import error from "../../../assets/images/error_card.svg";
import errorImg from "../../../assets/images/error_card.svg";
import { useInvoice } from "../../../hooks/useInvoice";
import { usePayload } from "../../../hooks/usePayload";
import { useEffect, useState } from "react";

const OrangeForm = () => {
  const { invoice, getWallet, id, getRedirectionURL, setCurrentStep } =
    useInvoice();
  const { payload, setPayload } = usePayload();

  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [isMsisdnVerified, setIsMsisdnVerified] = useState(false);
  const [otp, setOtp] = useState("");

  const [notification, setNotification] = useState({
    img: verified,
    title: "",
    text: ""
  });

  /* 🔁 Reset verification if number changes */
  useEffect(() => {
    setIsMsisdnVerified(false);
    setOtp("");
  }, [payload?.customer_msisdn]);

  const handleChange = (e) => {
    setPayload({ ...payload, [e.target.name]: e.target.value });
  };

  const handleVerifyNumber = (e) => {
    setIsLoading(true);
    e.preventDefault();
    setIsLoading(true);

    // send payload to server
    verifyMsisdin({
      customer_msisdn: payload?.customer_msisdn,
      payment_processor_id: getWallet("ORANGE_MONEY")?.public_id
    })
      .then((res) => {
        setIsLoading(false);
        if (res?.response?.valid) {
          setIsMsisdnVerified(true);
          setCurrentStep(2);
        } else {
          setNotification({
            img: errorImg,
            title: "Payment Pending",
            text: "Please check your number to complete the payment"
          });
          setIsOpen(true);
        }
      })
      .catch((err) => {
        setNotification({
          img: errorImg,
          title: "Payment Pending",
          text:
            err?.response?.data?.error?.customer_msisdn?.error_string ||
            "An error occurred, please try again"
        });
        setIsOpen(true);
        setIsLoading(false);
      });
  };

  const handleVerify = (e) => {
    e.preventDefault();
    setIsLoading(true);

    // send payload to server
    processCheckout({
      ...payload,
      invoice_id: id,
      otp: otp,
      payment_processor_id: getWallet("ORANGE_MONEY")?.public_id
    })
      .then(
        (res) => {
          setNotification({
            img: verified,
            title: "Payment Successful",
            text: "The payment has been made successfully."
          });
          setCurrentStep(3);
          setIsOpen(true);
          return res;
        },
        (err) => {
          setNotification({
            img: error,
            title: "Payment Unsuccessful",
            text:
              err.response?.message ??
              "The payment did not succeed because something went wrong."
          });
          setIsOpen(true);
          setIsLoading(false);
          return err;
        }
      )
      .then(({ response }) => {
        if (response?.data.response?.redirect_url) {
          const queryarams = getRedirectionURL({
            transaction_id: response.data.response.transaction_id,
            payment_processor: "Orange Money",
            status: response.data.status === "SUCCESS" ? "true" : "false"
          });
          setTimeout(() => {
            window.location.href = `${response.data.response.redirect_url}?${queryarams}`;
          }, 3500);
        }
      });
  };

  return (
    <>
      <form>
        <Input label="Email" fullWidth value={invoice?.email} disabled />

        <Input
          label="Wallet Number"
          fullWidth
          name="customer_msisdn"
          type="number"
          placeHolder="123456"
          value={payload?.customer_msisdn || ""}
          onChange={handleChange}
          prefix={
            <>
              <img className="logo" src="/flag.png" alt="country logo" />
              <span>+226</span>
            </>
          }
        />

        <VerificationBox
          walletName="Orange Money"
          disabled={!isMsisdnVerified}
          otp={otp}
          isCode={true}
          setOtp={setOtp}
        />

        <div className="text-center">
          <PrimaryButton
            disabled={
              isLoading ||
              (!isMsisdnVerified && !payload?.customer_msisdn) ||
              (isMsisdnVerified && !otp)
            }
            onClick={isMsisdnVerified ? handleVerify : handleVerifyNumber}
            text={
              <div className="verify-btn">
                {isLoading && (
                  <img
                    className="btn-loader"
                    src="https://raw.githubusercontent.com/Codelessly/FlutterLoadingGIFs/master/packages/cupertino_activity_indicator_square_medium.gif"
                    alt="Loading"
                  />
                )}
                {isLoading ? "Processing" : isMsisdnVerified ? "Pay" : "Verify"}
              </div>
            }
          />
        </div>
      </form>
      <PopUp
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        img={notification.img}
        title={notification.title}
        text={notification.text}
      />
    </>
  );
};

export default OrangeForm;
